// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {PostSepaValidationSuccess} from 'redux/v1/paymentTravel/sepa/validation/actions';
import type {SepaValidationResponse} from 'redux/v1/paymentTravel/sepa/validation/model';
import type {SepaValidationState} from 'redux/v1/paymentTravel/sepa/validation/SepaValidationState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  PURE,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {validationState} from 'redux/v1/paymentTravel/sepa/SepaState';
import {
  POST_PAYMENT_SEPA_VALIDATION,
  RESET_SEPA_VALIDATION,
} from 'redux/v1/paymentTravel/sepa/validation/actions';

export const initialState: SepaValidationState = {
  loading: false,
  data: null,
};

const actionCreators: ActionHandlers<SepaValidationState> = {
  [PENDING(POST_PAYMENT_SEPA_VALIDATION)]: (state: SepaValidationState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(POST_PAYMENT_SEPA_VALIDATION)]: (
    state: SepaValidationState,
    action: PostSepaValidationSuccess
  ) => ({
    ...state,
    loading: false,
    success: true,
    data: action.data,
    error: {},
  }),
  [ERROR(POST_PAYMENT_SEPA_VALIDATION)]: (
    state: SepaValidationState,
    action: any
  ) => ({
    ...state,
    loading: false,
    success: false,
    data: null,
    error: action.error,
  }),
  [PURE(RESET_SEPA_VALIDATION)]: (state: SepaValidationState) => ({
    loading: false,
    data: null,
  }),
};

export const validationReducer: Reducer<SepaValidationState> =
  // $FlowFixMe
  createReducerUsingActionHandlers<SepaValidationState>(
    initialState,
    actionCreators
  );

export const isLoaded: Selector<boolean> = createSelector(
  validationState,
  (state: SepaValidationState) =>
    !state.loading && state.success !== undefined
);

export const isLoading: Selector<boolean> = createSelector(
  validationState,
  (state: SepaValidationState) => state.loading
);

export const isSuccess: Selector<boolean> = createSelector(
  validationState,
  (state: SepaValidationState) => state.success
);

export const getValidationData: Selector<SepaValidationResponse> =
  createSelector(validationState, (state: SepaValidationState) => state?.data);

export const getValidationError: Selector<any> = createSelector(
  validationState,
  (state: SepaValidationState) => state?.error
);
